export default function styles(theme) {
    return {
      title: {
        display: "block",
        width: "100%",
        textAlign: "left",
        margin:"0rem",
        color: theme.palette.text.primary,
        [theme.breakpoints.down("sm")]: {
            textAlign:"center",
        },
      },
      secondaryTitle: {
        fontSize: "2rem",
        fontFamily: "Poppins",
        textAlign:"left",
        width: "100%",
        letterSpacing: "1px",
        color: theme.palette.text.primary,
        margin: "0rem",
        padding:"0rem",
        [theme.breakpoints.down("sm")]: {
          fontSize:  "2rem",
          textAlign:"center",
        },
      },
      description: {
        margin: "auto",
        display: "block",
        textAlign: "left",
        fontSize: "1rem",
        fontWeight:"200",
        padding:"1rem 0rem",
        color: theme.palette.text.tertiary,
        [theme.breakpoints.down("sm")]: {
            textAlign:"center",
        },
      },
      errorContainer: {
        border: '1px solid rgba(121, 131, 150, 0.15)',
        backgroundColor: theme.palette.primary.main,
        borderRadius:'20px',
        // padding: "2rem",
        alignContent: "center",
        padding:'0rem 2rem',
        display: "Grid",
        gridTemplateColumns: "1fr 1fr",
        alignItems:"center",
        gridGap: "4rem",
        margin:"2rem 0rem 5rem",
        [theme.breakpoints.down("sm")]: {
          gridTemplateColumns: "1fr",
          padding:'2rem 1rem',
          gridGap: "0rem",
        },
      },
      giphyContainer:{
        width:"100%"
      },
      img:{
        width: "100%",
        margin: "auto",
      },
      buttonContainer:{
          width: "100%",
          [theme.breakpoints.down("sm")]: {
            display:"flex",
          alignItems:"center",
          justifyContent:"center",
          },
          
      }
    };
  }
  